/** Converte ISO (YYYY-MM-DD) ou dd/mm[/aaaa] para Date local. */
export function parseNegotiationDate(value: string | undefined): Date | null {
  if (!value?.trim()) return null
  const trimmed = value.trim()
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    const [y, m, d] = trimmed.split('-').map(Number)
    const date = new Date(y, m - 1, d)
    return Number.isNaN(date.getTime()) ? null : date
  }
  const slash = trimmed.match(/^(\d{1,2})\/(\d{1,2})(?:\/(\d{2,4}))?$/)
  if (slash) {
    const day = Number(slash[1])
    const month = Number(slash[2])
    let year = slash[3] ? Number(slash[3]) : new Date().getFullYear()
    if (year < 100) year += 2000
    const date = new Date(year, month - 1, day)
    return Number.isNaN(date.getTime()) ? null : date
  }
  return null
}

/** Formata para input type="date" (YYYY-MM-DD). */
export function toNegotiationDateInputValue(value: string | undefined): string {
  const date = parseNegotiationDate(value)
  if (!date) return ''
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

/** Ex.: "Negociação válida para fechamentos até 15/06" */
export function formatNegotiationDeadlineSlideLabel(value: string | undefined): string {
  const date = parseNegotiationDate(value)
  if (!date) return ''
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const showYear = year !== new Date().getFullYear()
  const suffix = showYear ? `${dd}/${mm}/${year}` : `${dd}/${mm}`
  return `Negociação válida para fechamentos até ${suffix}`
}
